module.exports = "https://www.gc-pro.gnp.com.mx/891459a9b7b3fe0b16413fbc1765eafe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/image_bg.jpg
// module id = 8140
// module chunks = 0